export default __webpack_public_path__ + "static/mailbox-4d72219df8f6619d7a6d1325216a5ef7.jpg";